// Ensure jQuery is properly loaded in the Shopify theme
if (typeof jQuery === "undefined") {
  throw new Error(
    ">>> jQuery is not loaded. Please ensure jQuery is loaded before this script."
  );
}

// Main functionality encapsulated within jQuery to avoid conflicts
jQuery(document).ready(function ($) {
  console.log("custom bundle js loaded");
  // Store the original state of the form buttons
  var originalButtonHTML = $(".t4s-product-form__buttons").html();

  // On page load, set the first option as selected in each group and update the corresponding data list item
  $(".t4s-swatch__list").each(function () {
    var firstItem = $(this)
      .find(".t4s-swatch__item:first-child")
      .addClass("is--selected");
    updateOptionBundleData(firstItem);
  });

  // Check for sold out status initially and on each update
  isSoldOut();

  // Click event listener for selecting an option within the same list
  $(document).on("click", ".t4s-swatch__item", function () {
    $(this).siblings().removeClass("is--selected");
    $(this).addClass("is--selected");

    updateOptionBundleData($(this));
    isSoldOut();
  });

  function updateOptionBundleData(selectedItem) {
    var variantId = selectedItem.data("variant-id");
    var variantName = selectedItem.data("variant-name");
    var variantAvailable = selectedItem.attr("data-variant-available");

    var optionBundle = selectedItem.closest(".t4s-swatch__option_bundle");
    optionBundle.attr("data-variant-id", variantId);
    optionBundle.attr("data-variant-name", variantName);
    optionBundle.attr("data-variant-available", variantAvailable);
  }

  function isSoldOut() {
    let soldOut = false;
    $("#bundle-products-data-list .t4s-swatch__option_bundle").each(
      function () {
        let isAvailable = $(this).attr("data-variant-available");
        if (isAvailable === "false") {
          soldOut = true;
          return false; // Exit the loop early since we found a sold-out product
        }
      }
    );

    if (soldOut) {
      $(".t4s-product-form__buttons").html(
        `<button type="submit" class="t4s-btn t4s-product-form__submit" disabled is="custom-button">
                        <div>Sold out</div>
                    </button>`
      );
      $(".t4s-product-form__buttons .t4s-d-flex.t4s-flex-wrap").hide();
    } else {
      $(".t4s-product-form__buttons").html(originalButtonHTML);
      $(".t4s-product-form__buttons .t4s-d-flex.t4s-flex-wrap").show();
    }
  }

  function getFormData() {
    let cartItems = [];
    let globalBundleName = "";
    // let variantId = $(
    //   "#bundle-products-data-list .t4s-swatch__option_bundle:first"
    // ).data("variant-id");

    $("#bundle-products-data-list .t4s-swatch__option_bundle").each(
      function () {
        let quantity = parseInt($("[data-quantity-value]").val());
        let variantId = $(this).data("variant-id");
        let variantName = $(this).data("variant-name");
        let bundleName = $(this).data("bundle-name");
        globalBundleName = bundleName; // Assuming this is correct context for setting a global variable
        cartItems.push({
          id: variantId,
          title: variantName,
          quantity: quantity,
          properties: {
            Bundle: bundleName,
          },
        });
      }
    );
    return {
      note: globalBundleName,
      attributes: {
        "Bundle Name": globalBundleName,
      },
      items: cartItems,
    };
  }

  async function addToCart(formData) {
    try {
      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const responseJson = await response.json();
      if (response.ok) {
        const cartContent = await (
          await fetch(`${Shopify.routes.root}cart.js`)
        ).json();
        console.log(">>>JSON Response:", responseJson);
        cartContent["sections"] = responseJson["sections"];
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:change", {
            bubbles: true,
            detail: {
              baseEvent: "variant:add",
              cart: cartContent,
            },
          })
        );
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
          })
        );
      } else {
        console.error(">>> Error adding item to cart:");
      }
    } catch (error) {
      console.error(">>> Error adding item to cart:", error);
    }
  }

  async function buyNow(formData) {
    try {
      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      const jsonResponse = await response.json();
      console.log(">>> JSON Response:", jsonResponse);
      if (response.ok) {
        console.log(">>> redirecting to checkout");
        window.location.href = "https://halemons.com/checkout";
      } else {
        console.error(">>> Error adding item to cart:");
      }
    } catch (error) {
      console.error(">>> Error adding item to cart:", error);
    }
  }

  // Ensure if product is a bundle
  const isBundleProduct = $(".mainProductContainer").data("isbundleproduct");
  if (isBundleProduct === true) {
    console.log(">>>>>> isBundleProduct = true");

    // Event binding on Add To Cart button
    $(document).on(
      "click",
      ".t4s-product-form__buttons [data-atc-form]",
      async function (e) {
        console.log(">>> Add To Cart Button Clicked");
        e.preventDefault();
        let formData = getFormData();
        if (formData.items.length > 0) {
          console.log(">>> Form Data :- ", formData);
          await addToCart(formData);
        } else {
          console.error(">>> No form data to process.");
        }
      }
    );

    // Event binding on Buy Now button
    $(document).on(
      "click",
      ".shopify-payment-button .shopify-payment-button__button",
      async function (e) {
        console.log(">>> Buy Now button clicked");
        e.preventDefault();
        let formData = getFormData();
        if (formData.items.length > 0) {
          console.log(">>> Form Data :- ", formData);
          await buyNow(formData);
        } else {
          console.error(">>> No form data to process.");
        }
      }
    );
  }
});
